import React from 'react';
import { Card, CardBody } from 'reactstrap';
import KanbanEntregaCard from './KanbanEntregaCard';
import { countDueWindow, KANBAN_COLUMN_TITLES } from './dashboardEntregasHelpers';

export default function KanbanColumn({
  viewKey,
  items,
  today,
  selectedProdId,
  onSelectProduct,
}) {
  const title = KANBAN_COLUMN_TITLES[viewKey] || viewKey;
  const summary = countDueWindow(items, viewKey, { overdue: true, withinDays: 10 }, today);
  const list = Array.isArray(items) ? items : [];

  return (
    <Card
      style={{
        height: '100%',
        border: '1px solid #e9ecef',
        background: '#f8f9fa',
        minHeight: 320,
      }}
    >
      <CardBody className="d-flex flex-column" style={{ padding: 12, gap: 10, minHeight: 0 }}>
        <div>
          <div style={{ fontWeight: 800, fontSize: 14, color: '#4e515e', lineHeight: 1.3 }}>
            {title}
          </div>
          <div
            style={{
              fontSize: 12,
              color: '#6c757d',
              marginTop: 6,
              display: 'flex',
              flexWrap: 'wrap',
              gap: '4px 10px',
            }}
          >
            <span>
              <b style={{ color: '#4e515e' }}>{summary.total}</b>
              {' '}
              total
            </span>
            <span style={{ color: summary.overdue ? '#ff5757' : undefined }}>
              <b>{summary.overdue}</b>
              {' '}
              vencidas
            </span>
            <span>
              <b style={{ color: '#4e515e' }}>{summary.withinDays}</b>
              {' '}
              ≤10 dias
            </span>
          </div>
        </div>

        <div
          className="d-flex flex-column"
          style={{
            gap: 8,
            overflowY: 'auto',
            flex: 1,
            minHeight: 0,
            maxHeight: 'calc(100vh - 320px)',
            paddingRight: 2,
          }}
        >
          {list.length === 0 ? (
            <div
              style={{
                fontSize: 13,
                color: '#6c757d',
                padding: '16px 8px',
                textAlign: 'center',
              }}
            >
              Nenhum produto neste estado
            </div>
          ) : (
            list.map((product) => (
              <KanbanEntregaCard
                key={product.prod_id || `${product.proj_id}-${product.prod_desc}`}
                product={product}
                viewKey={viewKey}
                today={today}
                selected={Number(selectedProdId) === Number(product.prod_id)}
                onClick={() => onSelectProduct?.(product, viewKey)}
              />
            ))
          )}
        </div>
      </CardBody>
    </Card>
  );
}
